import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Navbar from './Navbar';
import MedicalChatBubble from './MedicalChatBubble';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const LoadingSkeleton = () => (
  <div style={{ minHeight: '100vh', background: 'var(--surface-body)' }}>
    <div style={{ height: 56, background: 'var(--color-slate-900)' }} />
    <div className="page-container">
      <div className="skeleton skeleton-line" style={{ width: 200, height: 28, marginBottom: 24 }} />
      <div className="grid grid-2">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="skeleton skeleton-card" />
        ))}
      </div>
    </div>
  </div>
);

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <LoadingSkeleton />;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <>
      <Navbar />
      {children}
      <MedicalChatBubble />
    </>
  );
};

export default PrivateRoute;
